// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-progress {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.progress-circle {
  position: relative;
  width: 120px;
  height: 120px;
  margin-bottom: 1.5rem;
}

.progress-background {
  stroke: #e5e7eb;
}

.progress-indicator {
  stroke: #0d9488;
  transition: stroke-dashoffset 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  font-weight: 500;
  color: #111827;
}

.progress-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #111827;
  margin: 0 0 0.5rem 0;
}

.progress-subtitle {
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/uploadAndRecording/UploadProgress.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX","sourcesContent":[".upload-progress {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.progress-circle {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  margin-bottom: 1.5rem;\n}\n\n.progress-background {\n  stroke: #e5e7eb;\n}\n\n.progress-indicator {\n  stroke: #0d9488;\n  transition: stroke-dashoffset 0.3s ease;\n}\n\n.progress-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.progress-title {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #111827;\n  margin: 0 0 0.5rem 0;\n}\n\n.progress-subtitle {\n  font-size: 1rem;\n  color: #6b7280;\n  margin: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
